/**
 * Hook del panel de ahorro de tokens del tenant (REQ-CHAT-039 §2/§7).
 *
 * Fuente: `GET /api/v1/tenants/{tid}/token-savings` (agregado horario en DB).
 */

import { useQuery } from '@tanstack/react-query';
import apiClient from '@/lib/api-client';

export interface TokenSavingsSeriesPoint {
  bucket: string;
  produced: number;
  sent: number;
  billable_equivalent: number;
  cost_effective?: number;
  cost_counterfactual?: number;
}

export interface TenantTokenSavings {
  window: string;
  unit: string;
  group_by: string;
  kpis: {
    savings_cost_pct?: number | null;
    savings_tokens_pct?: number | null;
    calls?: number;
    tokens?: Record<string, number>;
    cost?: Record<string, number>;
  };
  series: TokenSavingsSeriesPoint[];
}

export function useTenantTokenSavings(
  tenantId: string | undefined,
  window = '7d',
  unit: 'cost' | 'tokens' = 'cost',
) {
  return useQuery({
    queryKey: ['tenant-token-savings', tenantId, window, unit],
    enabled: Boolean(tenantId),
    retry: false,
    queryFn: async () => {
      const { data } = await apiClient.get<TenantTokenSavings>(
        `/api/v1/tenants/${tenantId}/token-savings`,  // absoluta: el cliente no la prefija
        { params: { window, unit, group_by: 'agent' } },
      );
      return data;
    },
  });
}
